// extracted by mini-css-extract-plugin
module.exports = {"primaryGrey":"#DADADA","header":"header_header__DPsTG","menu":"header_menu__iT_cz"};